import { render, staticRenderFns } from "./siteDiscount.vue?vue&type=template&id=4220ead4&scoped=true&lang=html"
import script from "./siteDiscount.vue?vue&type=script&lang=js"
export * from "./siteDiscount.vue?vue&type=script&lang=js"
import style0 from "./siteDiscount.vue?vue&type=style&index=0&id=4220ead4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4220ead4",
  null
  
)

export default component.exports